import React, { useEffect, useState } from "react";
import { deleteIcon, editIconInBox, plusBlueIcon } from "../../../assets";
import WrapperCard from "../../../component-lib/Atoms/card/EventEHRWrapperCard";
import Heading from "../../../component-lib/Atoms/heading/EventEHRHeading";
import Table from "../../../component-lib/Organisms/table/EventEHRTable";
import useDeviceType from "../../../custom-hooks/DeviceType";
import DischargeFormPreviewModel from "../../../utils/discharge-form-preview-model/DischargeFormPreviewModel";
import EventEHRVitalsCard from "../../../component-lib/Molecules/card/EventEHRVitalsCard";
import Input from "../../../component-lib/Atoms/Input/Input";
import EventEHRRadioButton from "../../../component-lib/Molecules/radioButton/EventEHRRadioButton";
import EventEHRPatientProfileDetailCard from "../../../component-lib/Organisms/patient-profile-detail-card/EventEHRPatientProfileDetailCard";
import { TEXT_CONSTANTS } from "../../../utils/text-constants/textConstants";
import DispositionDialog from "./dialogs/DispositionDialog";
import CreateOrderDialog from "./dialogs/CreateOrderDialog";
import EventEHRCreateOrderCard from "../../../component-lib/Molecules/create-order-card/EventEHRCreateOrderCard";
import EventEHRLinkTextWithIcon from "../../../component-lib/Atoms/link-text-with-icon/EventEHRLinkTextWithIcon";
import EventEHRCareVisitFlowButtons from "../../../component-lib/Molecules/care-visit-flow-buttons/EventEHRCareVisitFlowButtons";
import EventEHREditChiefComplaintDialog from "./dialogs/edit-chief-complaint-dialog/EventEHREditChiefComplaintDialog";
import {
  componentKey,
  setCloseChiefComplaintDialog,
  setCloseCreateOrderDialog,
  setCloseCreateTriageDrawer,
  setCloseDispositionDialog,
  setDataToDischargeForm,
  setUpdateVisitNoteDataOnceDraftNote,
} from "../patientSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteOrderItem,
  getVisitNoteById,
  patchVisitNoteData,
  postVisitNoteData,
} from "../patientSaga";
import {
  getPatientDetailsDataFunction,
  getTriageDetailsDataFunction,
  getDefaultSelectedCare,
  getDefaultSelectedCareValue,
  getSelectedCareTitle,
  getSelectedCarePlaceholder,
  TRIAGE_CARES,
  decideStatusOnButtonClick,
  setVisitNoteInfoDisable,
} from "../constants";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { eventEHRCustomToastMessage } from "../../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import Button from "../../../component-lib/Molecules/button/Button";
import TriageHistoryDialog from "./dialogs/TriageHistoryDialog";
import { createTriageClick } from "../create-patient-drawer/constants";
import DiagnosisCodeSelect from "./DiagnosisCodeSelect";
import SaveTriageDialog from "./SaveTriageDialog";
import IntervalNotesSection from "./IntervalNotesSection";

const NurseCareVisitFlow = () => {
  const {
    visitNoteCareFlowData,
    closeChiefComplaintDialog,
    closeCreateOrderDialog,
    closeDispositionDialog,
    isOrderChange,
    updateVisitNoteDataOnceDraftNote,
    notesData,
    closeTriageDrawer,
  } = useSelector((state: any) => state[componentKey]);

  const patientDetailsData = visitNoteCareFlowData;
  const triageDetailsData = visitNoteCareFlowData?.triage;
  const defaultSelectedTriageData = triageDetailsData?.[0];
  let index = visitNoteCareFlowData?.visit_note?.findIndex(
    (obj: any) => obj.id === notesData.id
  );
  // Set index to last  element if not found

  if (index === -1) {
    index = visitNoteCareFlowData?.visit_note?.length - 1;
  }

  const { patientId } = useParams();
  const navigate = useNavigate();

  const { visitNoteId } = useParams();
  const dispatch = useDispatch();
  const deviceType = useDeviceType();
  const [openDischargeForm, setOpenDischargeForm] = useState(false);
  const [selectedCare, setSelectedCare] = useState("woundCare");
  const [openDispositionDialog, setOpenDispositionDialog] = useState(false);
  const [openChiefComplaintDialog, setOpenChiefComplaintDialog] =
    useState(false);
  const [searchParams] = useSearchParams();
  const isAddNewNote = searchParams.get("isAddNewNote"); // Replace 'yourParam' with your parameter name
  const newNoteStatus = searchParams.get("newNoteStatus"); // Replace 'yourParam' with your parameter name
  const [addNewNote, setAddNewNote] = useState(isAddNewNote || false);
  const [selectedDiagnosis, setSelectedDiagnosis] = useState<any>([]);
  const [selectedDispositionKey, setSelectedDispositionKey] = useState("");
  const [dischargeNote, setDischargeNote] = useState("");
  const isPatientTransfer = isAddNewNote
    ? false
    : setVisitNoteInfoDisable(visitNoteCareFlowData?.status);

  // Interval notes are always available in this flow (same as Physician care).
  // The footer "File Interval Note" button commits the typed note.
  const [intervalNoteText, setIntervalNoteText] = useState("");
  const [showNewField, setShowNewField] = useState(false);
  const currentVisitNote = visitNoteCareFlowData?.visit_note?.[index];
  const intervalNotes = (visitNoteCareFlowData?.visit_note || [])
    .flatMap((vn: any) => vn?.intervalNotes || [])
    .sort(
      (a: any, b: any) =>
        new Date(a?.createdAt).getTime() - new Date(b?.createdAt).getTime()
    );

  const handleFileIntervalNote = () => {
    if (!intervalNoteText || intervalNoteText.trim().length === 0) {
      eventEHRCustomToastMessage({
        title: `Please enter an interval note.`,
        status: "error",
      });
      return;
    }
    // Persist any SOAP documentation entered so far (mirrors the draft-save
    // fields) so it isn't lost when filing the interval note.
    const soapDraftPayload = {
      historyOfPresent: formFieldData?.presentIllnessHistory || undefined,
      description: formFieldData?.description || undefined,
      plan: formFieldData?.plan || undefined,
      assessmentDescription: formFieldData?.assessmentDescription || undefined,
      ...(selectedDiagnosis?.length
        ? {
            assessment: selectedDiagnosis.map((data: any) => ({
              code: data?.label,
              desc: data?.description,
            })),
          }
        : {}),
    };
    const apiPayload = {
      status: "InInterval",
      ...soapDraftPayload,
      intervalNotes: [{ note: intervalNoteText.trim() }],
    };
    if (currentVisitNote?.id) {
      dispatch(
        patchVisitNoteData({
          apiPayload,
          comesFrom: "intervalNote",
          visitNoteId: currentVisitNote?.id,
          patientId,
          navigate,
        })
      );
    } else {
      dispatch(
        postVisitNoteData({
          apiPayload: { ...apiPayload, patientId, visitId: visitNoteId },
          comesFrom: "intervalNote",
          patientId,
          navigate,
        })
      );
    }
    setIntervalNoteText("");
    setShowNewField(false);
  };

  const [openTriageHistory, setOpenTriageHistory] = useState({
    isOpen: false,
    data: [],
  });
  const [openTriage, setOpenTriage] = useState(false);
  const [openCreateOrderDialog, setOpenCreateOrderDialog] = useState(false);
  const [defaultOrderType, setDefaultOrderType] = useState("rxOrder");

  // FORM DATA
  const [formFieldData, setFormFieldData] = useState({
    presentIllnessHistory: "",
    care: "woundCare",
    careValue: "s",
    description: "",
    assessmentDescription: "",
    plan: "",
  });

  // TRIAGE CARD DATA
  const triageCardData = getTriageDetailsDataFunction(triageDetailsData);

  // PATIENT DETAILS DATA
  const patientDetails = getPatientDetailsDataFunction(patientDetailsData);

  // ASSESSMENT TABLE COLUMNS
  const ICDCodeColumns = [
    {
      field: "srNo",
      label: <div>Sr No</div>,
      renderLogic: (row: any, index: any) => {
        return <p className="text-neutral-90 font-normal">{index + 1}</p>;
      },
    },
    {
      field: "code",
      label: <div>Code</div>,
      renderLogic: (row: any) => {
        return <p className="text-primary-main font-normal">{row?.label}</p>;
      },
    },
    {
      field: "details",
      label: <div className="w-[70vw]">Details</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.description}</p>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            {!isPatientTransfer && (
              <div className="flex items-center">
                <img
                  alt="delete-icon"
                  className="cursor-pointer"
                  src={deleteIcon}
                  width={"18px"}
                  height={"19.5px"}
                  onClick={() => {
                    // Delete Particular Item
                    setSelectedDiagnosis((prevItems: any) =>
                      prevItems.filter((item: any) => item.id !== row?.id)
                    );
                  }}
                />
              </div>
            )}
          </>
        );
      },
    },
  ];

  // RX ORDER COLUMNS
  const RXOrderColumns = [
    {
      field: "srNo",
      label: <div></div>,
      renderLogic: (row: any, index: any) => {
        return <p className="text-neutral-90 font-normal">{index + 1}</p>;
      },
    },
    {
      field: "medication",
      label: <div className="w-[10vw]">Medication</div>,
      renderLogic: (row: any) => {
        return <p className=" font-normal">{row?.item?.[0]?.medicationName}</p>;
      },
    },
    {
      field: "qty",
      label: <div className="w-[5vw]">Qty</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">
            {row?.item?.[0]?.quantity}
          </p>
        );
      },
    },
    {
      field: "unit",
      label: <div className="w-[5vw]">Unit</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal">{row?.item?.[0]?.unit}</p>
        );
      },
    },
    {
      field: "details",
      label: <div className="w-[20vw]">Details</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal common-text-ellipse-style">
            {row?.note}
          </p>
        );
      },
    },
    {
      field: "action",
      label: <div>{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              {!isPatientTransfer && (
                <img
                  alt="delete-icon"
                  className="cursor-pointer"
                  src={deleteIcon}
                  width={"18px"}
                  height={"19.5px"}
                  onClick={() => {
                    const payload = {
                      orderId: row?.id,
                      comesFrom: "",
                    };
                    dispatch(deleteOrderItem(payload));
                  }}
                />
              )}
            </div>
          </>
        );
      },
    },
  ];
  // NON RX ORDER COLUMNS
  const nonRXColumns = [
    {
      field: "srNo",
      label: <div></div>,
      renderLogic: (row: any, index: any) => {
        return <p className="text-neutral-90 font-normal">{index + 1}</p>;
      },
    },
    {
      field: "orderType",
      label: <div className="w-[10vw]">Order Type</div>,
      renderLogic: (row: any) => {
        return (
          <p className="font-normal">
            {row?.type?.split("_")?.join(" ") || "-"}
          </p>
        );
      },
    },
    {
      field: "Items",
      label: <div className="w-[10vw]">Items</div>,
      renderLogic: (row: any) => {
        return <p className="font-normal">{row?.item?.[0]?.name || "-"}</p>;
      },
    },
    {
      field: "details",
      label: <div className="w-[50vw]">Details</div>,
      renderLogic: (row: any) => {
        return (
          <p className="text-neutral-90 font-normal  common-text-ellipse-style">
            {row?.note}
          </p>
        );
      },
    },
    {
      field: "action",
      label: <div className="w-[10%]">{TEXT_CONSTANTS?.ACTION}</div>,
      renderLogic: (row: any) => {
        return (
          <>
            <div className="flex items-center">
              {!isPatientTransfer && (
                <img
                  alt="delete-icon"
                  className="cursor-pointer"
                  src={deleteIcon}
                  width={"18px"}
                  height={"19.5px"}
                  onClick={() => {
                    const payload = {
                      orderId: row?.id,
                      comesFrom: "",
                    };
                    dispatch(deleteOrderItem(payload));
                  }}
                />
              )}
            </div>
          </>
        );
      },
    },
  ];

  const rxORowData = isOrderChange
    ? visitNoteCareFlowData?.visit_note?.[index]?.order?.filter(
        (data: any) => data?.type === "Rx Order"
      )
    : [];
  const noneRXRowData = isOrderChange
    ? visitNoteCareFlowData?.visit_note?.[index]?.order?.filter(
        (data: any) => data?.type !== "Rx Order"
      )
    : [];

  // CLOSE DISPOSITION DIALOG
  useEffect(() => {
    if (closeDispositionDialog) {
      dispatch(setCloseDispositionDialog(false));
      setOpenDispositionDialog(false);
      setOpenDischargeForm(true);
    }
  }, [closeDispositionDialog]);

  // CLOSE CREATE ORDER DIALOG
  useEffect(() => {
    if (closeCreateOrderDialog) {
      setOpenCreateOrderDialog(false);
      dispatch(setCloseCreateOrderDialog(false));
    }
  }, [closeCreateOrderDialog]);

  // Select default triage data
  useEffect(() => {
    if (triageDetailsData?.length) {
      setSelectedCare(getDefaultSelectedCare(defaultSelectedTriageData));
    }

    setFormFieldData((prevData: typeof formFieldData) => ({
      ...prevData,
      careValue: getDefaultSelectedCareValue(defaultSelectedTriageData), // Default value
      care: getDefaultSelectedCare(defaultSelectedTriageData),
    }));
  }, [triageDetailsData, defaultSelectedTriageData]);

  // UPDATE DRAFT DATA IF EXISTS
  useEffect(() => {
    // Update selectedDiagnosis based on provided data or fallback to default
    if (
      !addNewNote ||
      newNoteStatus === "InDisposition" ||
      newNoteStatus === "Visit Created" ||
      newNoteStatus === "Draft" ||
      newNoteStatus === "InInterval"
    ) {
      setSelectedDiagnosis(
        selectedDiagnosis?.length
          ? selectedDiagnosis.map((data: any, index: number) => ({
              id: data?.code,
              index,
              label: data?.label,
              value: data?.value,
              description: data?.description,
            }))
          : visitNoteCareFlowData?.visit_note?.[index]?.assessment?.map(
              (data: any, index: number) => ({
                id: data?.code,
                index,
                label: data?.code,
                value: data?.code,
                description: data?.desc,
              })
            ) || []
      );

      setFormFieldData((prevData: any) => ({
        ...prevData,
        presentIllnessHistory:
          prevData?.presentIllnessHistory ||
          visitNoteCareFlowData?.visit_note?.[index]?.historyOfPresent ||
          "",
        description:
          prevData?.description ||
          visitNoteCareFlowData?.visit_note?.[index]?.description ||
          "",
        plan:
          prevData?.plan ||
          visitNoteCareFlowData?.visit_note?.[index]?.plan ||
          "",
        assessmentDescription:
          prevData?.assessmentDescription ||
          visitNoteCareFlowData?.visit_note?.[index]?.assessmentDescription ||
          "",
      }));
    }
  }, [visitNoteCareFlowData]);

  useEffect(() => {
    dispatch(
      setDataToDischargeForm({
        ...visitNoteCareFlowData,
        assessment: selectedDiagnosis,
      })
    );
  }, [visitNoteCareFlowData, selectedDiagnosis]);

  // ONCE CHIEF COMPLAINT DIALOG CLOSE REFRESH DATA
  useEffect(() => {
    if (closeChiefComplaintDialog) {
      setOpenChiefComplaintDialog(false);
      dispatch(setCloseChiefComplaintDialog(false));
    }
    if (updateVisitNoteDataOnceDraftNote) {
      dispatch(setUpdateVisitNoteDataOnceDraftNote(false));
    }
    if (closeTriageDrawer) {
      setOpenTriage(false);
      dispatch(setCloseCreateTriageDrawer(false));
    }

    const payload = {
      id: visitNoteId,
      comesFrom: "nurseCare",
    };
    dispatch(getVisitNoteById(payload));
  }, [
    closeChiefComplaintDialog,
    updateVisitNoteDataOnceDraftNote,
    closeCreateOrderDialog,
    closeDispositionDialog,
    closeTriageDrawer,
  ]);



  // DRAFT VISIT NOTE DATA
  const handleButtonClick = (status: any, extraParams?: string) => {
    // CHECK IF ICD 10 CODE SELECTED OR NOT IF NOT THEN RETURN FROM  FUNCTION
    if (extraParams !== "comesFromOrder") {
      if (!selectedDiagnosis || selectedDiagnosis?.length === 0) {
        eventEHRCustomToastMessage({
          title: `Please select at least one ICD-10 code.`,
          status: "error",
        });
        return;
      }
    }
    if (visitNoteCareFlowData?.triage?.length === 0) {
      eventEHRCustomToastMessage({
        title: `Please add vitals.`,
        status: "error",
      });
      return;
    }
    // Open the disposition dialog only after the save succeeds (passed to the
    // saga as onSuccess). Undefined for Draft saves so they never open it.
    const onSuccess =
      status !== "Draft"
        ? () => setOpenDispositionDialog(true)
        : extraParams === "draftSave"
          ? () => navigate(`/patient/${patientId}?tab=visits`)
          : undefined;

    // Carry an un-filed interval note into this save (Proceed to Discharge) so
    // it isn't lost. Not on order-driven saves.
    const pendingInterval = intervalNoteText?.trim();
    const intervalNotePayload =
      extraParams !== "comesFromOrder" && pendingInterval
        ? { intervalNotes: [{ note: pendingInterval }] }
        : {};
    try {
      if (visitNoteCareFlowData?.visit_note.length === 0) {
        const payload = {
          apiPayload: {
            historyOfPresent: formFieldData?.presentIllnessHistory || undefined,
            description: formFieldData?.description || undefined,
            plan: formFieldData?.plan || undefined,
            patientId: patientId,
            assessmentDescription:
              formFieldData?.assessmentDescription || undefined,
            visitId: visitNoteId,
            assessment: selectedDiagnosis?.map((data: any) => ({
              code: data?.label,
              desc: data?.description,
            })),
            status: status,
            ...intervalNotePayload,
          },
          comesFrom: extraParams,
          navigate,
          onSuccess,
        };
        dispatch(postVisitNoteData(payload));
      } else if (
        addNewNote &&
        !(
          newNoteStatus === "InDisposition" ||
          newNoteStatus === "Visit Created" ||
          newNoteStatus === "Draft"
        )
      ) {
        setAddNewNote(false);
        const payload = {
          apiPayload: {
            historyOfPresent: formFieldData?.presentIllnessHistory || undefined,
            description: formFieldData?.description || undefined,
            plan: formFieldData?.plan || undefined,
            patientId: patientId,
            assessmentDescription:
              formFieldData?.assessmentDescription || undefined,
            visitId: visitNoteId,
            assessment: selectedDiagnosis?.map((data: any) => ({
              code: data?.label,
              desc: data?.description,
            })),
            status: status,
            ...intervalNotePayload,
          },
          comesFrom: extraParams,
          navigate,
          onSuccess,
        };
        dispatch(postVisitNoteData(payload));
      } else {
        const payload = {
          apiPayload: {
            historyOfPresent: formFieldData?.presentIllnessHistory || undefined,
            description: formFieldData?.description || undefined,
            plan: formFieldData?.plan || undefined,
            assessmentDescription:
              formFieldData?.assessmentDescription || undefined,
            assessment: selectedDiagnosis?.map((data: any) => ({
              code: data?.label,
              desc: data?.description,
            })),
            status: status,
            ...intervalNotePayload,
          },
          comesFrom: extraParams,
          visitNoteId: visitNoteCareFlowData?.visit_note?.[index]?.id,
          navigate,
          onSuccess,
        };
        dispatch(patchVisitNoteData(payload));
      }
      if (pendingInterval && extraParams !== "comesFromOrder") {
        setIntervalNoteText("");
      }

      dispatch(
        setDataToDischargeForm({
          ...visitNoteCareFlowData,
          assessment: selectedDiagnosis,
        })
      );
      // The disposition dialog is now opened by `onSuccess` from the saga, only
      // after the visit-note save succeeds (not here, regardless of result).
    } catch (error) {
      console.log("error:", error);
    }
  };

  return (
    <WrapperCard
      customClasses="m-3 p-3 pl-4 pr-4 flex-1 min-h-0 overflow-auto"
      customStyle={{ minWidth: deviceType !== "mobile" ? "400px" : "" }}
    >
      <div className="flex flex-col justify-between gap-3 h-full">
        <div className="flex flex-col justify-between gap-3 overflow-hidden">
          {/* HEADING */}
          <Heading title="Visit Note" customStyle={{ color: "#1D1D1D" }} />
          {/* MAIN CONTENT */}
          <div className="pr-2 overflow-auto">
            {/* PROFILE INFO CARD */}
            <div className="flex background-color-F1F1F1 border-radius-8px py-4 px-6">
              <EventEHRPatientProfileDetailCard
                isOpenHealthHistoryPresent={true}
                patientDetails={patientDetails}
                patientId={patientId}
              />
            </div>
            {/* TRIAGE CARD */}
            <div className="mt-5 mb-3 flex flex-col gap-3">
              <div className="flex justify-between items-center">
                <Heading
                  title="Vitals"
                  customStyle={{
                    color: "#393939",
                    fontWeight: 500,
                    fontSize: "16px",
                  }}
                />
                {triageDetailsData?.length !== 0 && (
                  <div className="flex justify-between gap-4">
                    <Button
                      label="Add Rpt Vitals"
                      onClickCb={() => {
                        setOpenTriage(true);
                      }}
                      style={{ background: "white" }}
                      variant={"outlined"}
                    />
                    <Button
                      label="View Vitals History"
                      onClickCb={() => {
                        setOpenTriageHistory({
                          isOpen: true,
                          data: triageDetailsData,
                        });
                      }}
                      style={{ background: "white" }}
                      variant={"outlined"}
                    />
                  </div>
                )}
              </div>
              {triageDetailsData?.length !== 0 ? (
                <div className="flex flex-wrap gap-3">
                  {triageCardData &&
                    triageCardData[0]?.map((data: any, index: any) => (
                      <EventEHRVitalsCard
                        key={index}
                        label={data?.label}
                        temperature={data?.temperature}
                        title={data?.title}
                        unit={data?.unit}
                      />
                    ))}
                </div>
              ) : (
                <div className="text-[#fd4d4d] font-medium	">
                  No Vitals Found.{" "}
                  <span
                    style={{
                      textDecoration: "underline",
                      cursor: "pointer",
                      color: "rgb(0, 85, 150)",
                    }}
                    onClick={() => setOpenTriage(true)}
                  >
                    Add New Vitals
                  </span>
                </div>
              )}
            </div>
            {/* SUBJECTIVE */}
            <div className="flex flex-col pt-3">
              <Heading
                title={TEXT_CONSTANTS?.SUBJECTIVE}
                customStyle={{
                  fontWeight: 500,
                  color: "#1D1D1D",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              />
              <div className="flex justify-between items-center mb-2">
                <Heading
                  title="Chief Complaint"
                  customStyle={{
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "#565656",
                  }}
                />
                {!isPatientTransfer && (
                  <img
                    alt="edit-icon"
                    src={editIconInBox}
                    width={"36px"}
                    height={"36px"}
                    className="cursor-pointer"
                    onClick={() => {
                      setOpenChiefComplaintDialog(true);
                    }}
                  />
                )}
              </div>
              <div>
                <div
                  className="font-weight-500 border-radius-8px color-979797"
                  style={{
                    padding: "14px 16px",
                    border: "1px solid #D2D2D2",
                    background: "#F8F8F8",
                  }}
                >
                  {visitNoteCareFlowData?.chiefComplaints}
                </div>
                {/* HISTORY OF PRESENT ILLNESS FIELD  */}
                <div className="mt-2">
                  <Heading
                    title="History of Present Illness"
                    customStyle={{
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#565656",
                      marginBottom: "8px",
                    }}
                  />
                  <Input
                    rows={3}
                    disabled={isPatientTransfer}
                    size="small"
                    textFieldLabel="Enter History of Present Illness here"
                    multiline={true}
                    maxWords={250}
                    name="presentIllnessHistory"
                    value={formFieldData.presentIllnessHistory}
                    onChangeCb={(e: any) => {
                      setFormFieldData((prevData: any) => ({
                        ...prevData,
                        presentIllnessHistory: e?.target?.value,
                      }));
                    }}
                  />
                </div>
              </div>
              {/* OBJECTIVE */}
              {/* <div className="mt-6">
                <Heading
                  title="Objective"
                  customStyle={{
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "#1D1D1D",
                    marginBottom: "8px",
                  }}
                />
                <div className="ml-2 mr-2 mb-4">
                  <EventEHRRadioButton
                    disabled
                    selectedValue={selectedCare}
                    name=""
                    labelCustomStyle={{
                      marginLeft: "10px",
                      color: "#565656",
                    }}
                    optionList={TRIAGE_CARES}
                    handleOnChange={(value) => {
                      setSelectedCare(value);
                      setFormFieldData((prevData: any) => ({
                        ...prevData,
                        care: value,
                        careValue: "",
                      }));
                    }}
                  />
                </div>
                <div>
                  <div>
                    <Heading
                      title={getSelectedCareTitle(selectedCare)}
                      customStyle={{
                        fontWeight: 500,
                        fontSize: "16px",
                        color: "#393939",
                        marginBottom: "12px",
                      }}
                    />
                    <div style={{ maxWidth: "660px" }}>
                      <Input
                        disabled
                        label=""
                        placeholder={getSelectedCarePlaceholder(selectedCare)}
                        name={"careValue"}
                        value={formFieldData?.careValue}
                        onChangeCb={(e) => {
                          setFormFieldData((prevData: any) => ({
                            ...prevData,
                            careValue: e.target.value,
                          }));
                        }}
                        size="small"
                      />
                    </div>
                  </div>
                </div>
              </div> */}
              {/* Description */}
              <div className="mt-4">
                <Heading
                  title="Description"
                  customStyle={{
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "#565656",
                    marginBottom: "8px",
                  }}
                />
                <Input
                  rows={3}
                  disabled={isPatientTransfer}
                  maxWords={250}
                  size="small"
                  placeholder="Enter Description"
                  multiline
                  name="description"
                  value={formFieldData.description}
                  onChangeCb={(e: any) => {
                    setFormFieldData((prevData: any) => ({
                      ...prevData,
                      description: e?.target?.value,
                    }));
                  }}
                />
              </div>

              {/* TABLE */}
              <div className="mt-6">
                <Heading
                  title="Assessment"
                  customStyle={{ fontSize: "16px" }}
                />

                {/* Assessment Description */}
                <div className="mt-2">
                  <Input
                    disabled={isPatientTransfer}
                    rows={3}
                    maxWords={250}
                    placeholder={"Enter Assessment Description"}
                    multiline
                    size="small"
                    name="assessmentDescription"
                    value={formFieldData.assessmentDescription}
                    onChangeCb={(e: any) => {
                      setFormFieldData((prevData: any) => ({
                        ...prevData,
                        assessmentDescription: e?.target?.value,
                      }));
                    }}
                  />
                </div>

                <div className="mt-6">
                  <DiagnosisCodeSelect
                    setSelectedDiagnosis={setSelectedDiagnosis}
                    isPatientTransfer={isPatientTransfer}
                  />
                </div>
              </div>

              <div className="overflow-auto mb-2 mt-6 max-h-[350px]">
                <Table
                  columns={ICDCodeColumns}
                  rows={selectedDiagnosis}
                  noDataFoundMessage={"No ICD 10 Code entered"}
                />
              </div>

              {/* Order */}
              {!isOrderChange ? (
                <EventEHRCreateOrderCard
                  handleClickEvent={() => {
                    handleButtonClick("Draft", "comesFromOrder");
                    setOpenCreateOrderDialog(true);
                  }}
                />
              ) : (
                (!visitNoteCareFlowData?.visit_note?.[index]?.order ||
                  visitNoteCareFlowData?.visit_note?.[index]?.order?.length ===
                    0) && (
                  <EventEHRCreateOrderCard
                    handleClickEvent={() => {
                      handleButtonClick("Draft", "comesFromOrder");
                      setOpenCreateOrderDialog(true);
                    }}
                  />
                )
              )}
              {/* RX ORDER TABLE */}
              {rxORowData?.length > 0 && (
                <div className="mt-6">
                  <Heading
                    title="Rx Order"
                    customStyle={{
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#-",
                      marginBottom: "8px",
                    }}
                  />
                  <Table
                    columns={RXOrderColumns}
                    rows={rxORowData}
                    noDataFoundMessage={"No Data"}
                  />
                </div>
              )}
              {/* NON Rx ORDER TABLE */}
              {noneRXRowData?.length > 0 && (
                <div className="mt-6">
                  <Heading
                    title="Non Rx Order"
                    customStyle={{
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#-",
                      marginBottom: "8px",
                    }}
                  />
                  <Table
                    columns={nonRXColumns}
                    rows={noneRXRowData}
                    noDataFoundMessage={"No Data"}
                  />
                </div>
              )}
              {/* ADD ORDER (generic - opens order type picker) */}
              {!isPatientTransfer &&
                (rxORowData?.length > 0 || noneRXRowData?.length > 0) && (
                  <div className="flex justify-center mt-4">
                    <div
                      onClick={() => {
                        setDefaultOrderType("rxOrder");
                        if (
                          visitNoteCareFlowData?.visit_note?.[index]?.status !==
                          "Draft"
                        ) {
                          handleButtonClick("Draft", "comesFromOrder");
                        }
                        setOpenCreateOrderDialog(true);
                      }}
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        padding: "8px 24px",
                        border: "1px solid #005596",
                        borderRadius: "8px",
                        backgroundColor: "#E8F1F8",
                        cursor: "pointer",
                      }}
                    >
                      <EventEHRLinkTextWithIcon
                        linkText="Add Order"
                        imageSrc={<img src={plusBlueIcon} alt="add-icon" />}
                        labelCustomStyle={{
                          fontWeight: 600,
                          fontSize: "14px",
                          color: "#005596",
                          cursor: "pointer",
                        }}
                        handleClickEvent={() => {}}
                      />
                    </div>
                  </div>
                )}

              {/* Plan */}
              <div className="mt-6">
                <Heading
                  title="Plan"
                  customStyle={{
                    fontSize: "16px",
                    fontWeight: 500,
                    color: "#565656",
                    marginBottom: "8px",
                  }}
                />
                <Input
                  rows={3}
                  disabled={isPatientTransfer}
                  placeholder="Enter Plan"
                  multiline
                  name="plan"
                  size="small"
                  maxWords={250}
                  value={formFieldData.plan}
                  onChangeCb={(e: any) => {
                    setFormFieldData((prevData: any) => ({
                      ...prevData,
                      plan: e?.target?.value,
                    }));
                  }}
                />
              </div>
              {/* INTERVAL NOTES (moved to bottom — used for ongoing reassessments) */}
              <div className="pt-3">
                <IntervalNotesSection
                  intervalNotes={intervalNotes}
                  isReadOnly={isPatientTransfer}
                  noteText={intervalNoteText}
                  onNoteTextChange={setIntervalNoteText}
                  showNewField={showNewField}
                  onAddMore={() => setShowNewField(true)}
                />
              </div>
            </div>
          </div>
        </div>
        {/* FOOTER BUTTONS */}
        {!isPatientTransfer && (
          <EventEHRCareVisitFlowButtons
            isTransferButtonPresent={false}
            isFileIntervalNotePresent={true}
            handleFileIntervalNoteButtonClickEvent={handleFileIntervalNote}
            handleCancelButtonClickEvent={() => {
              navigate(`/patient/${patientId}?tab=visits`);
              console.log("Cancel");
            }}
            handleSaveAsDraftButtonClickEvent={() => {
              handleButtonClick("Draft", "draftSave");
            }}
            handleProceedToDischargeButtonClickEvent={() => {
              const status = decideStatusOnButtonClick(visitNoteCareFlowData);
              handleButtonClick(status);
            }}
          />
        )}
      </div>
      {openDischargeForm && (
        <DischargeFormPreviewModel
          patientId={patientId}
          visitNoteId={visitNoteId}
          selectedDispositionKey={selectedDispositionKey}
          dischargeNote={dischargeNote}
          open={openDischargeForm}
          comesFrom={selectedDispositionKey !== "discharged" ? "soapNote" : ""}
          handleCloseModel={() => {
            // if (selectedDispositionKey !== "discharged") {
            //   navigate(`/patient/${patientId}?tab=visits`, { replace: true });
            // }
            setSelectedDispositionKey("");
            setOpenDischargeForm(false);
          }}
        />
      )}
      {openCreateOrderDialog && (
        <CreateOrderDialog
          defaultSelectedOrderType={defaultOrderType}
          handleCloseDialog={() => {
            setOpenCreateOrderDialog(false);
          }}
          open={openCreateOrderDialog}
        />
      )}
      {openDispositionDialog && (
        <DispositionDialog
          patientId={patientId}
          visitNoteId={visitNoteCareFlowData?.visit_note?.[index]?.id}
          open={openDispositionDialog}
          handleCloseDialog={() => {
            setOpenDispositionDialog(false);
          }}
          handleDischargeClick={(type, data) => {
            if (type === "discharged") {
              setSelectedDispositionKey("discharged");
              setDischargeNote(data);
              setOpenDischargeForm(true);
            }
          }}
        />
      )}
      {/* EDIT CHIEF COMPLAINT DIALOG */}
      {openChiefComplaintDialog && (
        <EventEHREditChiefComplaintDialog
          defaultSelectedData={visitNoteCareFlowData?.chiefComplaints}
          dialogHeading="Edit Chief Complaint"
          isOpen={openChiefComplaintDialog}
          handleClose={() => {
            setOpenChiefComplaintDialog(false);
          }}
        />
      )}
      {openTriageHistory?.isOpen && (
        <TriageHistoryDialog
          triageData={openTriageHistory?.data}
          open={openTriageHistory?.isOpen}
          handleClose={() => {
            setOpenTriageHistory({ isOpen: false, data: [] });
          }}
        />
      )}
      {openTriage && (
        <SaveTriageDialog
          ids={{
            visitId: visitNoteCareFlowData?.id,
            patientId: visitNoteCareFlowData?.patientId,
            typeOfCare: visitNoteCareFlowData?.typeOfCare,
          }}
          open={openTriage}
          handleCloseDialog={() => {
            setOpenTriage(false);
          }}
          handleTriageSubmittedData={(formData) => {
            createTriageClick(
              formData,
              visitNoteCareFlowData?.patientId,
              visitNoteCareFlowData?.id,
              dispatch
            );
          }}
        />
      )}
    </WrapperCard>
  );
};

export default NurseCareVisitFlow;
